'use strict';

var React = require('react');
var _ = require('lodash');
var ClassNames = require('classnames');
var InlineError = require('./InlineError.jsx');
var InlineMessage = require('./InlineMessage.jsx');
var ApplicationConstants = require('../../constants/ApplicationConstants');
var InlineInfoMessage = require('./InlineInfoMessage.jsx');
var InlineInfoButton = require('./InlineInfoButton.jsx');
var Spinner = require('./Spinner.jsx');

var TextInput = React.createClass({

    getInitialState: function () {
        return {
            value: this.props.value || '',
            hideHelpText: true
        };
    },

    propTypes: {
        id: React.PropTypes.string.isRequired,
        label: React.PropTypes.string,
        maxLength: React.PropTypes.number,
        isValid: React.PropTypes.bool,
        className: React.PropTypes.string,
        errorHeading: React.PropTypes.string,
        errorMessage: React.PropTypes.string,
        onChange: React.PropTypes.func,
        onBlur: React.PropTypes.func,
        // FIXME: OnChange only triggers after onBlur, try onKeyUp instead
        onKeyUp: React.PropTypes.func,
        onKeyPress: React.PropTypes.func,
        isHidden: React.PropTypes.bool,
        errorList: React.PropTypes.array,
        rightText: React.PropTypes.string,
        mandatory: React.PropTypes.bool,
        contextualMessage: React.PropTypes.string,
        type: React.PropTypes.oneOf(['text', 'password', 'date']),
        customClass: React.PropTypes.string,
        helpText: React.PropTypes.string,
        copyText: React.PropTypes.string,
        bottomText: React.PropTypes.string,
        hideBottomText: React.PropTypes.bool,
        model: React.PropTypes.string,
        size: React.PropTypes.string,
        symbol: React.PropTypes.oneOf(['currency', 'percent', 'none']),
        isLoadingComplete: React.PropTypes.bool
    },

    getDefaultProps: function () {
        return {
            isValid: true,
            isHidden: false,
            mandatory: true,
            type: 'text',
            helpText: '',
            hideBottomText: false,
            isDisabled: false,
            hasWarning: false,
            size: 'input-lg',
            isLoadingComplete: true
        };
    },

    _onChange: function (event) {
        this.setState({
            value: event.target.value
        });
        if (this.props.onChange) {
            this.props.onChange(event);
        }
    },

    toggleShowHideHelpText: function () {
        this.setState({
            hideHelpText: !this.state.hideHelpText
        });
    },

    inlineErrorMessage: function () {
        var errorMessage = null;
        //if errorList is passed, use it otherwise use errorHeading / errorText
        if (this.props.errorList) {
            var errorOfTheField = _.filter(this.props.errorList, { id: this.props.id });
            if (errorOfTheField.length > 0 && errorOfTheField[0]) {
                errorMessage = (<InlineMessage key={this.props.key}
                                               id={'inline-message-' + this.props.id}
                                               isHidden={!errorOfTheField[0].message}
                                               type={errorOfTheField[0].type}
                                               message={errorOfTheField[0].message} />);
            }
        } else if (this.props.errorHeading || this.props.errorMessage){
            errorMessage = <InlineError className="alert alert-warning" isHideError={this.props.errorList || this.props.isValid} header={this.props.errorHeading || 'Invalid ' + this.props.label} message={this.props.errorMessage } />;
        }
        return errorMessage;
    },

    componentWillReceiveProps: function (nextProps) {
        this.setState({ value: nextProps.value });  //update internal state
    },

    handleOnBlur: function(event){
      if(this.props.onBlur){
        event.target['model'] = this.props.model;
        this.props.onBlur(event);
      }
    },

    handleOnKeyDown: function(event){
        // only for date fields to remove a separator 
        if(this.props.placeholder === ApplicationConstants.DateFormat && event.keyCode === 8){
          let date = event.target.value;
          if (date.slice(-1) == '/') {
            event.target.value = date.slice(0, -1);
          }
        }
    },

    handleOnKeyUp: function(event){
      if(this.props.onKeyUp){
        event.target['model'] = this.props.model;
        this.props.onKeyUp(event);
      }
    },

    handleOnKeyPress: function(event){
      if(this.props.onKeyPress){
        event.target['model'] = this.props.model;
        this.props.onKeyPress(event);
      }
      // only for date fields to add a separator 
      if(this.props.placeholder === ApplicationConstants.DateFormat){
        let date = event.target.value;
        const regex = ApplicationConstants.DecimalRegex;
        if( !regex.test(String.fromCharCode(event.charCode)) ) {
          event.preventDefault();
          return false;
        } else if(date.length === 1 || date.length === 4){
			date += (String.fromCharCode(event.charCode) + '/');
            event.preventDefault();
			event.target.value = date;
		}
      }
    },

    inputFocus(){
        this.refs['input-' + this.props.id].focus();
    },

    render: function () {
        var x = this.props.removable ? <a id={'x-' + this.props.id} onClick={this.props.onRemoving }><i className="icon icon-cancel" /></a> : null;
        var arrow = (<span className={ClassNames('infoButton__arrow', { hidden: this.state.hideHelpText })} leftPos={this.state.leftPos } />);
        var rightText = !this.props.mandatory || this.props.rightText ? <span className="optional"> {this.props.mandatory || 'optional '} {this.props.rightText}{x}{arrow}</span> : null;
        
        var errorMessage = this.inlineErrorMessage();
        return (
               <div className={ClassNames({ 'form-section': Boolean(this.props.label) }, this.props.customClass, { 'has-warning': errorMessage || this.props.hasWarning }, { hidden: this.props.isHidden })}>
                    {this.props.label ? <div className="form-label-section">
                                            <label htmlFor={this.props.id }>{this.props.label}</label>
                                            <InlineInfoButton helpText={this.props.helpText} isHidden={this.state.hideHelpText} toggleShowHideHelpText={this.toggleShowHideHelpText} />
                                        </div>
                                      : null}
                    <InlineInfoMessage isHidden={this.state.hideHelpText} message={this.props.helpText} />
                    {this.props.copyText ? <p dangerouslySetInnerHTML={{ __html: this.props.copyText }} /> : null }
                   <span className={ClassNames({ 'input-lg input-symbol': Boolean(this.props.symbol) }, this.props.symbol)}>
                    <input id={this.props.id}
                           ref={'input-' + this.props.id}
                           name={this.props.id}
                           type={this.props.type}
                           autoComplete="off"
                           className={ClassNames('form-control', this.props.className, this.props.size, { 'text-input-left': !this.props.isLoadingComplete })}
                           value={this.state.value}
                           maxLength={this.props.maxLength}
                           onChange={this._onChange}
                           onBlur={this.handleOnBlur}
                           onKeyDown={this.handleOnKeyDown}
                           onKeyUp={this.handleOnKeyUp}
                           onKeyPress={this.handleOnKeyPress}
                           placeholder={this.props.placeholder}
                           disabled={this.props.isDisabled} />{rightText}
                   </span>{this.props.isLoadingComplete ? null : (<Spinner customClass="center-spinner" />)}
                   { //don't display contextual message when there is error message
                      errorMessage ||
                      <InlineMessage key={this.props.key}
                                  id={'contextual-message-' + this.props.id}
                                  type={ApplicationConstants.messageTypes.info}
                                  message={this.props.contextualMessage}
                                  isHidden={!this.props.contextualMessage} /> }
                   {this.props.bottomText ? <div className={ClassNames('form-sub-section', { hidden: this.props.hideBottomText })} dangerouslySetInnerHTML={{ __html: this.props.bottomText } } /> : null}
                </div>
            );
    }
});

module.exports = TextInput; 


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/TextInput.jsx